var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 11 9"}},[_c('path',{attrs:{"fill":_vm.color,"d":"m10.125.001-6.35 7.11-2.513-2.8-.875.944L3.774 9 11 .945l-.875-.944Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }